import { render, staticRenderFns } from "./PriceUpdate.vue?vue&type=template&id=80eac73a&scoped=true&"
import script from "./PriceUpdate.vue?vue&type=script&lang=js&"
export * from "./PriceUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80eac73a",
  null
  
)

export default component.exports